import './product-shop.css';
import loaderCard from '../loader-card/loader-card.module';

const ProductShop = class ProductShop extends HTMLElement {
    constructor() {
        super();
        this.routeTerms = JSON.parse(this.getAttribute('route-terms'));
        this.shopFeed = this.querySelector('#shopFeed');
        this.form = this.querySelector('form');
        this.resetButton = this.querySelector('[reset-btn]')
    }

    attributeChangedCallback (name, oldValue, newValue) {
        switch (name) {
            case 'route-terms':
                this.routeTerms = JSON.parse(newValue);
                break;
        }
        this.submitForm();
    }

    render (formData) {
        loaderCard.show(this);
        let url = '/handler/searchHandler.ashx?' + new URLSearchParams({
            call: 'search'
        });

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.text())
            .then(html => {
                this.shopFeed.innerHTML = html;

                document.querySelectorAll('.add-to-cart').forEach(function (form) {
                    form.querySelector('input[type=number]').addEventListener('input', scSystem.onExpectedQuantityChanged);
                    form.addEventListener('submit', scSystem.addToCartSubmit);
                });
                loaderCard.hide(this);
            });
    }

    submitForm (pageNumber = 0) {
        const formData = {
            page: pageNumber,
            query: this.querySelector('[data-query]').value,
            routeTerms: this.routeTerms,
            filters: {}
        };

        this.querySelectorAll('select').forEach(select => {
            let selectedOptions = Array.from(select.selectedOptions).map(opt => opt.value);
            let key = select.closest('multi-select').getAttribute('key');
            formData.filters[key] = selectedOptions;
        });

        this.render(formData);
    }

    connectedCallback () {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submitForm();
        });

        let debounceTimeout;
        this.form.querySelector('[data-query]').addEventListener('input', (e) => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                this.submitForm();
            }, 700);
        });

        this.resetButton.addEventListener('click', (e) => {
			this.form.querySelectorAll('select').forEach(select => {
				const multiSelect = select.closest('multi-select');
				if (multiSelect) {
					const title = multiSelect.getAttribute('title');
					if (title === 'Availability') {
						multiSelect.selectControl.setSelects(['In Stock']);
					} else {
						multiSelect.resetValues();
					}
				}
			});

            const pageInput = this.querySelector('input[name=page]');
            if (pageInput) {
                pageInput.value = 0;
            }
            this.querySelector('[data-query]').value = '';
            this.submitForm();
        });
    }
}

customElements.define('product-shop', ProductShop);